import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Login from "../views/Login.vue";
import SignUp from "../views/SignUp.vue";
import PasswordRecovery from "../views/PasswordRecovery.vue";
import ListView from "../views/ListView.vue";
import BrowseListsView from "../views/BrowseListsView.vue";
import BrowseUsersView from "../views/BrowseUsersView.vue";
import PlacesView from "../views/PlacesView.vue";
import Parse from 'parse';
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: ListView,
    // meta: { requiresAuth: true},
    beforeEnter: (to, from, next) => {
      if (Parse.User.current()) {
        next();
      } else {
        next("/browse/lists");
      }
    }
  },
  {
    path: "/list/:objectId",
    name: "list",
    component: PlacesView,
    props: true
  },
  {
    path: "/browse/lists",
    name: "browseLists",
    component: BrowseListsView,
    props: true
  },
  {
    path: "/browse/users",
    name: "browseUsers",
    component: BrowseUsersView,
    props: true
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/signup",
    name: "signup",
    component: SignUp
  },
  {
    path: "/recover-password",
    name: "passwordrecovery",
    component: PasswordRecovery
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue")
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,  root: "/"
});

export default router;
